// Active rules pill summary — extracted from RosterDetail.jsx iter34.

const ActiveRulesPanel = ({ activeRules, onManageClick }) => {
  if (!activeRules || activeRules.length === 0) return null;

  return (
    <div className="bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 p-4" data-testid="active-rules-summary">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-xs uppercase tracking-[0.2em] text-zinc-500 dark:text-zinc-400">
          Active Rules ({activeRules.length})
        </h3>
        <button
          onClick={onManageClick}
          className="text-xs text-[#002FA7] dark:text-blue-400 hover:underline"
          data-testid="manage-rules-link"
        >
          Manage rules →
        </button>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {activeRules.map((r) => (
          <span
            key={r.rule_id}
            className={`inline-flex items-center gap-1.5 px-2 py-1 text-xs rounded border ${
              r.is_hard
                ? 'bg-red-50 dark:bg-red-900/30 border-red-200 dark:border-red-800/50 text-red-700 dark:text-red-300'
                : 'bg-blue-50 dark:bg-blue-900/30 border-blue-200 dark:border-blue-800/50 text-blue-700 dark:text-blue-300'
            }`}
            data-testid={`active-rule-${r.rule_id}`}
            title={r.name}
          >
            <span className="font-medium">{r.name}</span>
            <span className="text-[10px] uppercase tracking-wide opacity-70">
              {r.is_hard ? "Hard" : "Soft"}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default ActiveRulesPanel;
